import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { ToDoListItem } from 'components/we-raise-common/ToDoList';
import { useAuthContext } from 'context/authContext';
import { useDonorContext } from 'context/donorContext';
import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AssignedStaffCard from './relationManagement/AssignedStaffCard';
import CommentFormModal from './relationManagement/CommentFormModal';
import DonorCommentsTable from './relationManagement/DonorCommentsTable';
import DonorTaskFormModal from './relationManagement/DonorTaskFormModal';
import SelectStaffModal from './relationManagement/SelectStaffModal';
import IconButton from 'components/common/IconButton';
import {
  useDonorTasks,
  useCreateDonorTask,
  useUpdateDonorTask,
  useDeleteDonorTask,
  useCreateDonorComment,
  useUpdateDonorAssignedStaff
} from 'hooks/useDonors';

const DonorRelationManagement = () => {
  const {
    donor: { user: assignedStaff, id: donorId }
  } = useDonorContext();
  const { user } = useAuthContext();
  const [showCommentForm, setShowCommentForm] = useState(false);
  const [showAddDonorForm, setShowAddDonorForm] = useState(false);
  const [showSelectStaffModal, setShowSelectStaffModal] = useState(false);

  // Fetch donor tasks
  const { tasks, isLoading: tasksLoading } = useDonorTasks(donorId);

  // Mutations
  const { createComment, isCreating: createCommentLoading } = useCreateDonorComment();
  const { createTask, isCreating: insertDonorTaskLoading } = useCreateDonorTask();
  const { updateTask } = useUpdateDonorTask();
  const { deleteTask } = useDeleteDonorTask();
  const { updateAssignedStaff, isUpdating: editAssignedStaffLoading } = useUpdateDonorAssignedStaff();

  const handleChange = async (id, completed) => {
    updateTask({
      id,
      data: { is_complete: completed }
    });
  };

  const handleDelete = async (id) => {
    deleteTask(id);
  };

  const weDonorCommunicationData = [
    {
      title: 'Send E-Mail',
      text: 'Send email to the donor',
      icon: 'envelope',
      color: 'primary',
      disabled: true
    },
    {
      title: 'Start a meeting',
      text: 'Start or schedule a meeting',
      icon: 'video',
      color: 'warning',
      disabled: true
    },
    {
      title: 'Create a Task',
      text: 'Create a to do task',
      icon: 'clipboard',
      color: 'danger',
      onClick: () => setShowAddDonorForm(true)
    },
    {
      title: 'Start a Call',
      text: 'Log a call or start one',
      icon: 'phone-alt',
      color: 'success',
      disabled: true
    },
    {
      title: 'Notes',
      text: 'Add comments and remarks',
      icon: 'user-cog',
      color: '',
      onClick: () => setShowCommentForm(true)
    },
    {
      title: 'Contact owner',
      text: 'Assign a staff',
      icon: 'user-cog',
      color: 'info',
      onClick: () => openSelectStaffModal()
    }
  ];

  const handleCreateDonorComment = async (data) => {
    createComment({
      description: data.comment,
      donor_id: donorId,
      reporter_id: user.id
    });
    setShowCommentForm(false);
  };

  const handleCreateDonorTask = async (data) => {
    createTask({
      description: data.description,
      donor_id: donorId,
      assignee: user.id,
      is_complete: false
    });
    setShowAddDonorForm(false);
  };

  const openSelectStaffModal = () => setShowSelectStaffModal(true);
  const closeSelectStaffModal = () => setShowSelectStaffModal(false);
  const onSubmitSelectStaffModal = async ({ assignedStaff }) => {
    updateAssignedStaff({
      donorId,
      staffId: assignedStaff
    });
    closeSelectStaffModal();
  };
  return (
    <>
      {/* {showCommentForm && ( */}
      <CommentFormModal
        show={showCommentForm}
        onHide={() => setShowCommentForm(false)}
        onSubmit={handleCreateDonorComment}
        loading={createCommentLoading}
      />
      <SelectStaffModal
        show={showSelectStaffModal}
        onHide={closeSelectStaffModal}
        onSubmit={onSubmitSelectStaffModal}
        loading={editAssignedStaffLoading}
        initialValues={{
          assignedStaff: assignedStaff?.id
        }}
      />
      {/* )} */}
      {/* {showCommentForm && ( */}
      <DonorTaskFormModal
        show={showAddDonorForm}
        onHide={() => setShowAddDonorForm(false)}
        onSubmit={handleCreateDonorTask}
        loading={insertDonorTaskLoading}
      />
      {/* )} */}

      <Row className="g-3 mb-3">
        <Col xs={12}>
          <Card className="h-100">
            <FalconCardHeader
              title={
                <>
                  <h5 className="text-primary">
                    Welcome to Contact Relation management center!
                  </h5>
                  <h6 className="text-600">
                    Here are some quick links for you to start
                  </h6>
                </>
              }
              titleTag="div"
              className="pb-1"
              // menuClassName="align-items-start"
              // endEl={<CardDropdown />}
            />

            <Card.Body className="z-index-1">
              <Row className="g-2 h-100 align-items-end">
                {weDonorCommunicationData.map(
                  ({ icon, color, title, disabled, text, onClick }) => {
                    return (
                      <Col sm={6} md={4} key={title}>
                        <button
                          onClick={onClick}
                          className="btn d-flex justify-content-start position-relative mb-2 w-100"
                          disabled={disabled}
                        >
                          <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2">
                            <FontAwesomeIcon
                              icon={icon}
                              className={`text-${color}`}
                            />
                          </div>
                          <div className="flex-1 text-start">
                            <Link to="#!" className="stretched-link text-800">
                              <h6 className="mb-0">{title}</h6>
                            </Link>
                            <p className="mb-0 fs--2 text-500 ">{text}</p>
                          </div>
                        </button>
                      </Col>
                    );
                  }
                )}
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="g-3 mb-3">
        <Col md={7}>
          <AssignedStaffCard handleSelectStaff={openSelectStaffModal} />
        </Col>
        <Col md={5}>
          <Card>
            <FalconCardHeader
              title="Tasks"
              light={false}
              titleTag="div"
              endEl={
                <IconButton
                  icon="pen"
                  variant="falcon-default"
                  className="fs--1 bg-transparent shadow-none p-0"
                  onClick={() => setShowAddDonorForm(true)}
                />
              }
            />
            <Card.Body className="p-0 overflow-hidden">
              {tasks.map((item, index) => (
                <ToDoListItem
                  key={item.id}
                  item={item}
                  index={index}
                  length={tasks.length}
                  setTodoItems={() => {}} // Not needed with Supabase hooks
                  handleChange={handleChange}
                  onDelete={handleDelete}
                />
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md={12} xxl={12} className="h-md-100">
          <DonorCommentsTable
            donorId={donorId}
            setShowCommentForm={setShowCommentForm}
          />
        </Col>
      </Row>
    </>
  );
};

export default DonorRelationManagement;
